module.exports = __webpack_public_path__ + "img/customer-service.ed244acc.png";